import API from "../../../app/api";

export const getcategorybanner = async () => {
  try {
    const res = await API.get("banners/categories");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Category Banner");
    }
    console.log(res.data); // logging the correct variable
    return res.data.data;
  } catch (error) {
    console.error("getcategorybanner error:", error);
    throw error;
  }
};